<template>
    <div class="findjobs bg-light">
        <Navbar/>
        <div class="container-fluid mt-5">
            <div class="pt-5">
                <!-- <h2 class="mt-4 font-weight-bolder">Find Top Software Jobs </h2>
                <button class="btn-kovatek text-uppercase mt-2 py-2 px-4 add-rounded-1">get started</button> -->
                <h3 class="font-weight-bolder mt-4 kova-text">Browse software jobs based on the category</h3>
            </div>

            <div class="m-auto container">
        <!-- <div class="d-flex justify-content-around flex-wrap"> -->
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/web-app"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/004-edit-tools.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">Web Application</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Front-end Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Back-end Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
          </div>

          <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/ui-ux"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/028-creativity.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">UI/UX Design</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Front-end Design Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">UI/UX Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/mobile-app"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/029-application-1.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">Desktop & Mobile Application</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Software Development Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Mobile App Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h mt-5">
              <!-- <router-link to="/dev-services/mobile-app"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/026-machine-learning-2.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">Data Science & Analytics</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Data Visualization Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">A/B Testing Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Data Analytics Jobs</p>
                    </div>
                </div>
              <!-- </router-link> -->
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/cyber-security"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/029-application-1.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">CyberSecurity</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Information Security Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Network System security Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
            </div>
          
          <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/blockchain"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/017-blockchain-1.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">Blockchain & DApps</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Blockchain Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">DApps Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
            </div>

          
          <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/artificial-intelligence"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/005-think.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">Artificial Intelligence</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">Machine Learning Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">A. I. Jobs</p>

                    </div>
                </div>
              <!-- </router-link> -->
          </div>

            <div class="col-sm-12 col-md-6 col-lg-3 mx-auto cont-h w-90 mt-5">
              <!-- <router-link to="/dev-services/devops"> -->
                <div class="col-12 available-devs bg-white shadow m-auto p-0">
                  <div class="bg-dark-kova devs-skills-img">
                    <img class="devs-img bg-dark-kova mt-3" src="../assets/png/040-data.png">
                  </div>
                    <div class="mt-3 text-left w-100 bg-white pl-3">
                      <h6 class="pb-1 font-weight-bold">DevOps, QA, Testing & Integration</h6>
                      
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">System Administration Jobs</p>
                        <p class="kova-text ctrl-size-2 py-0 mt-0 mb-1">DevOps Jobs</p>
                    </div>
                </div>
              <!-- </router-link> -->
            </div>

    </div>
    </div>   
        </div>

        <!-- <div class="py-5 mt-5">
          <div class="mt-5 border shadow jobs-width-adjust m-auto">
            <div class="bg-light py-4 border border-top-0">
                <h4 class="text-left ml-5 text-capitalize">Browse tops jobs on kovatek </h4>
            </div>
            <div class="p-4 bg-white">
              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Front end Developers needed for modifying existing applications</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$150</h6>
                    <p class="font-weight-lighter lighten-text text-left">Fixed Price</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Less than 15 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">2 - 3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Junior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>I have an existing front-end application written in simple HTML, CSS, JS and jQery. No fancy framework.
                    This calls back-end API and presents some pages.
                  </p>
                  <p> I need the following enhancement here </p>
                  <ol>
                    <li>The page has videojs integrated for playng HLS. I need some modifications here to add
                      multiple players.
                    </li>
                    <li>A new page to be created which will call back-end API and build the HTML.</li>
                  </ol>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Web Application Developer (Python/Django)</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$26/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                   <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>About Role & Team: We are a fast paced Startup with a user base growing 30% month on month. We love innovation
                    and we love seeing our Product grow. We love to see leadership quality from our dev team.
                  </p>
            
                  <div class="p-2">
                    <div class="text-left d-flex flex-wrap">
                      
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Full Stack</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Python</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Django</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">ORM</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Platform Development</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Database Design</span> 
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Front-end Technologies</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Leadership Qualities</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Complete development on graphing application on rails,
                      support application on python
                    </h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$15/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">2 - 3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Intemediate</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>Complete partially developed ruby on rails graphing application. Provide ongoing support (hourly as needed)
                    for this application. Be ready for technical integration.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Python</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Ruby</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Ruby on Rails</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Website Development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> PureScript expert for Mobile and Web development</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$22/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>Klictap is a startup beting big on haskell and PureScript. We have about 300 lines of front-end
                    and back-end code written in PureScript and Haskell.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Haskell</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Elm</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Website Development</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Design</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Android App Development</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Mobile App Development</span>

                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text">Programmer ReactJS + Redux</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$15/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Intermediate</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>It is neccessary to create a web version of one of the areas of our mobile application. 
                    What Exactly is need are:
                  </p>
                  <ol>
                    <li>Configure deploy on our server. Put Reat on it and so on.
                    </li>
                    <li>Create a front-end on ReactJS + Redux.</li>
                    <li>The task should be fully consistent with the design.</li>
                  </ol>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">ReactJS</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Redux</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Ubuntu</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Back-end Kotlin Developer required for business web apps</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$15/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10- 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Intermediate</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>We are embarking on building a series of web and mobile apps for a client and require a strong Kotlin
                    developer to help us build the back-end.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">React.js</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Kotlin</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web application development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Front-end Angular Engineer needed for 3 month project</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$3500</h6>
                    <p class="font-weight-lighter lighten-text text-left">Fixed Price</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4"></h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>Foskey Linex is an agency building custom software and digital solutions in web, mobile, IoT, as well as serial
                    enterpreneurs and innovators.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Angular</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">jQuery</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">TypeScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">KnockoutJS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Unit Testing</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> React Developer Needed</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$2000</h6>
                    <p class="font-weight-lighter lighten-text text-left">Fixed Price</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4"></h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Intermediate</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>As a React Developer, you will help develop the next generation of our apps using tools such as 
                    React.js, Redux, and Webpack. you should be familiar with React and its ecosystem.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">React.js</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Redux</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS3</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML5</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Website Development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> NodeJS/Full stack Developer needed - Remote full-time</h6>
                  </router-link>
                    
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Full time</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Intermediate</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>We are a UK based startup looking for a talented full-time NodeJS developer to join our diverse team.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">React.js</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">React Native</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Node.js</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">ElectronJS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Desktop Application</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Mobile App Development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                    <h6 class="text-left font-weight-bold kova-text">Android App Developer</h6>
                    <h6 class="font-weight-bolder text-left mt-4">$18/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">2 - 3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">.</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>A mobile app developer to be member of the team to design, development and maintain Android appp.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Java(J2EE / J2ME)</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">jQuery</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML5</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Android SDK</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">SQLite</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">MySQL</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Android App Developement</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Mobile App Developement</span>

                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Full Stack Developer/Designer (Experience with building marketplaces and the wellness industry)</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$4000</h6>
                    <p class="font-weight-lighter lighten-text text-left">Fixed Price</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">.</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">2 - 3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>My name is James Phil and I am driven to increase the impact of wellness brands globally. We are building here at Live4Life
                    a platform connecting wellness brands and wellness business growth experts and hire the best talent to help them achieve their
                    business growth goals.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">PHP</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Ruby on Rails</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML5</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">WordPress</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Design</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Part time job in C# & Selenium - for automation software</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$10/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Junior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>You will work part time. It's a long time project where you'll sometimes work more and sometimes less, depending
                    on need and budget. We will be using Git and preferably Gitflow.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Selenium</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">C#</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web automation</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">DevOps</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Integration</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> AB Testing Consultant Needed!</h6>
                  </router-link>
                  
                    <h6 class="font-weight-bolder text-left mt-4">$10/hr</h6>
                    <p class="font-weight-lighter lighten-text text-left">hourly</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">1 - 3 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>We are a UI/UX agency in Southern California and looking for a consultant who specialize in data, testing, analysis.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Usability Testing</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Competitive Analysis</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Conversion Rate</span>
                      <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Optimization</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div>
                <div class="">
                  <router-link to="job-description">
                    <h6 class="text-left font-weight-bold kova-text"> Web Designer and developer for integrating, tracking and analytics</h6>
                  </router-link>
                    <h6 class="font-weight-bolder text-left mt-4">$3000</h6>
                    <p class="font-weight-lighter lighten-text text-left">Fixed Price</p>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">10 - 30 hrs/week</h6>
                    <p class="font-weight-lighter lighten-text text-left">Hours needed</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">3 - 6 Months</h6>
                    <p class="font-weight-lighter lighten-text text-left">Duration</p>
                  </div>
                  <div class="col-md-4">
                    <h6 class="font-weight-bolder text-left mt-4">Senior</h6>
                    <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                  </div>
                </div>
                <div class="text-left">
                  <p>We are looking for a web designer and developer whovab help develop product landing pages for AB testing.
                  </p>
                  <div class="p-4">
                    <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Google Analitics</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Mixpanel</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Landing Pages</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Design</span>
                    <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web Development</span>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

            </div>
          </div>
        </div> -->

        <div class="pt-5"></div>
        <div class="container my-5">
          <div class="pb-4 bg-white border shadow-sm add-rounded">
          <div class="bg-light py-4 border border-top-0 add-rounded">
            <h4 class="text-left ml-5 text-capitalize">Browse tops jobs on kovatek </h4>
          </div>
          <div  class="px-lg-5 pt-2" :key="work" v-for="work in workHistory">
              <div class="row px-3">
              <!-- <div class="class col-3 col-sm-3 col-md-2 pl-1">
                  <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
              </div> -->
              <div class="col-12 col-sm-12 col-md-8 text-left">
                  <router-link to="/job-details">
                      <h4 class="font-weight-bolder kova-text">{{work.title}}</h4>
                  </router-link>
              </div>
              <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-4 float-text">
                      <h5 class="font-weight-bolder kova-text">$69 - $250</h5>
              </div>
              <div class="px-3">
                  <p class="text-size2 text-left">{{work.comment}}</p>
              </div>
              <div class="col-12 col-lg-9 text-left">
                  <!-- <span>
                      <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                      <span class="font-weight-light">{{work.duration}}</span>
                  </span> -->
                  <!-- <span class="ctrl-size text-uppercase my-0 intermediate font-weight-bolder">intermediate</span> -->
                  <!-- <span class="ctrl-size mb-1"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark ml-4 mr-1"></font-awesome-icon>Lagos, Nigeria</span> -->

                  <div class="row mt-2">
                      <div class="col">
                          <h6 class="font-weight-bolder ctrl-size-2 text-uppercase my-0 intermediate">intermediate</h6>
                          <p class="ctrl-size">Experience Level</p>
                      </div>
                      <div class="col">
                          <h6 class="font-weight-bolder ctrl-size-2"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>Lagos, Nigeria</h6>
                          <p class="ctrl-size ml-3">Location</p>
                      </div>
                      <div class="col">
                          <h6 class="font-weight-bolder ctrl-size-2">10 - 30 hrs/week</h6>
                          <p class="ctrl-size">Hours needed</p>
                      </div>
                      <div class="col">
                          <h6 class="font-weight-bolder ctrl-size-2">3 - 6 Months</h6>
                          <p class="ctrl-size">Duration</p>
                      </div>
                      <div class="col">
                          <h6 class="font-weight-bolder ctrl-size-2">$26/hr</h6>
                          <p class="ctrl-size">Hourly</p>
                      </div>
                  </div>
                  <p class="text-left font-weight-bolder ctrl-size mb-1"><font-awesome-icon class="ctrl-size" icon="clock" /> 30 minutes ago for</p>
                  <p class="text-left font-weight-bolder ctrl-size my-0"><span class=" kova-green mr-2"><font-awesome-icon class="ctrl-size mr-2" icon="gavel" />2 bids</span><font-awesome-icon class="ctrl-size" icon="tag" /> PHP, Website Design, Wordpress, CSS, HTML</p>
                  
              </div>
          </div>
          <hr>
          </div>
          <a-pagination showQuickJumper :defaultCurrent="2" :total="500" @change="peginationChange" />
        </div>
      </div>
        <GetHired />          
        <Footer />
    </div>
</template>
<script>

import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import GetHired from '@/components/GetHired.vue';


export default {
    name: 'findjobs',
    components: {
        Navbar, Footer, GetHired
    },
    data(){
      return {
        workHistory: [
                {title: 'Customise Wordpress login', duration: ' Mar 2016 - Sep 2018', star: 5, status:"You are hired", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Wordpress login', star: 5, status:"Undergoing Interview", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Design sign up and user authentication', duration: ' Mar 2016 - Sep 2018', star: 5, status:"Undergoing Interview", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'UX wireframes', star: 5, status:"Lost Bid", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Customise Wordpress login', duration: ' Mar 2016 - Sep 2018', star: 5, status:"Lost Bid", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Customise Wordpress login', star: 5, status:"Lost Bid", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
            ],
            stacks: [
                'React', 'Angular', 'Vue', 'Kotlin', 'Python', 'Go', 'JavaScript',
                'PHP', 'Nodejs', 'Django', 'Flask', 'Laravel', 'Java', 'C#', 'C++', '.NET', 
                'Ruby', 'Scala', 'Perl', 'Symfony', 'Spring', 'JSF', 'Others'
                ],
      }
    }
}
</script>
<style scoped>
.available-devs{
  height: 220px;
  width: 200x;
}
.ctrl-size{
    font-size: 11px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 12px;
}
.add-kovatek-bg{
  background-color: #20409a;
}
.kova-text{
  color:#20409a;
}
.kova-text-p{
  font-size: 13px;
}
.w-94{
  width:94%;
}
.devs-skills-img{
  height: 100px;
}
.devs-img{
  height: 60%;
}
.bg-dark-kova{
  /* background-color:#1D4354; */
  background-color: #20409a;
}
.bg-skills{
  background-color: #dde;
  transition: 0.1s;
}
.bg-skills:hover{
  background-color: #20409a;
  color: #fff;
}
.jobs-width-adjust{
  width: 75%;
}

.btn-outline-kovatek{
  background-color: #20409a;
  border: solid 1px #20409a;
  outline: 0;
  color: #fff;
  width: 200px;
  height: 50px;
  transition: .25s;
  border-radius: 5px;
  font-size: 16px;
}
.btn-outline-kovatek:hover{
  background-color: #06216d;
  border: solid 1px #06216d;
  color: #fff;
}
.lighten-text{
  color: #777
}

@media screen and (min-width: 992px) and (max-width: 1325px){
.adjust-w{
  width: 97%;
}
.available-devs{
  height: 220px;
  width: 220px;
}
.jobs-width-adjust{
  width: 80%;
}

}
@media screen and (min-width: 768px) and (max-width: 991px){
  .adjust-w{
  width: 80%;
  }
.match-height{
  height:auto;
}
.jobs-width-adjust{
  width: 90%;
}
  
}
@media screen and (max-width: 767px){
.match-height{
  height:auto;
}
.available-devs{
  height: 250px;
  width: 80%;
}
.devs-skills-img{
  height: 150px;
}
.jobs-width-adjust{
  width: 100%;
}

}
@media screen and (max-width: 550px){
  .available-devs{
    height: 250px;
    width: 98%;
  }
}
</style>